import type { ReportDimension } from "@gettactic/api";
import { useDivisionsQuery } from "@gettactic/hooks";
import { useMemo } from "react";
import { buildLocationTree, type LocationNode } from "../lib/locationTree";

const EMPTY: never[] = [];

const membersOf = (dimensions: ReportDimension[], key: string) =>
  dimensions.find((d) => d.key === key)?.members ?? EMPTY;

/**
 * The organization's locations as the tree the pickers share: divisions,
 * the offices the catalog lets the caller see and, for the floor kind, the
 * floors under each office. Offices sit at the top until the divisions
 * arrive.
 */
export const useLocationTree = (
  dimensions: ReportDimension[],
  leaf: "office" | "floor"
): LocationNode[] => {
  const { divisions } = useDivisionsQuery();
  const offices = membersOf(dimensions, "office");
  const floors = membersOf(dimensions, "floor");
  return useMemo(
    () =>
      buildLocationTree(
        divisions.data ?? EMPTY,
        offices,
        leaf === "floor" ? floors : undefined
      ),
    [divisions.data, offices, floors, leaf]
  );
};
